/**
 * Conversion TSL vers hexadecimal.
 *
 * C'est de la PRESENTATION, pas du jugement. Le moteur possede sa propre
 * mesure de distance (OKLab, dans `color.ts` cote serveur) et c'est lui seul
 * qui note la reponse. Ici on ne fait que traduire la position de deux
 * curseurs en la chaine `#rrggbb` que le protocole attend.
 *
 * TSL plutot qu'un disque en canvas : deux commandes lineaires se pilotent au
 * clavier, se decrivent a un lecteur d'ecran, et n'exigent pas de lire des
 * pixels — donc aucune surface a redessiner a chaque image.
 */

function toHex(channel: number): string {
  return Math.round(Math.min(255, Math.max(0, channel * 255)))
    .toString(16)
    .padStart(2, '0');
}

/**
 * @param h teinte en degres, 0 a 360
 * @param sat saturation, 0 a 1
 * @param light luminosite, 0 a 1
 */
export function hslToHex(h: number, sat: number, light: number): string {
  const chroma = (1 - Math.abs(2 * light - 1)) * sat;
  const section = (((h % 360) + 360) % 360) / 60;
  const second = chroma * (1 - Math.abs((section % 2) - 1));
  const base = light - chroma / 2;

  const [r, g, b] =
    section < 1 ? [chroma, second, 0]
    : section < 2 ? [second, chroma, 0]
    : section < 3 ? [0, chroma, second]
    : section < 4 ? [0, second, chroma]
    : section < 5 ? [second, 0, chroma]
    : [chroma, 0, second];

  return `#${toHex(r + base)}${toHex(g + base)}${toHex(b + base)}`;
}
